module.exports = __webpack_public_path__ + "manifest.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/manifest.json
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/manifest.json
// module chunks = 40